import { stopPropagation } from '../../../../../../utils/events'

export function useRentalPortalPhotoGalleryTileOverlayActions({
  onOpen,
  onRemove,
  onRetry,
  onSetCover,
}) {
  function getHandleAction(action) {
    return event => {
      stopPropagation(event)

      action(event)
    }
  }

  return {
    handleOpen: getHandleAction(onOpen),
    handleRemove: getHandleAction(onRemove),
    handleRetry: getHandleAction(onRetry),
    handleSetCover: getHandleAction(onSetCover),
  }
}
